import React from 'react';

import { Paragraph } from '@app/shared/ui/atoms/Common/Paragraph';
import { cn } from '@app/shared/utils/common';

interface AppVersionProps extends React.HTMLAttributes<HTMLParagraphElement> {
  version?: string;
  isText?: boolean;
  isGitHash?: boolean;
}

export function AppVersion({ version, className, isText, isGitHash }: AppVersionProps) {
  return (
    <Paragraph variant="secondary" size="xs" className={cn('text-center text-white', className)}>
      {isText !== false && 'Version: '}
      {version ?? import.meta.env.VITE_APP_VERSION}
      {isGitHash !== false && ` (${import.meta.env.VITE_GIT_HASH as string})`}
    </Paragraph>
  );
}
